import { initCacheInvalidatorRegister } from '../cacheRegisterConstructor';

export enum DocumentFoldersCacheEvents {
  CREATE = 'CREATE',
  UPDATE = 'UPDATE',
  DELETE = 'DELETE',
}

type CacheParams = {
  organizationId: string;
};

const cacheRegister = initCacheInvalidatorRegister<
  typeof DocumentFoldersCacheEvents,
  CacheParams
>(DocumentFoldersCacheEvents);

export const invalidateDocumentFoldersCache = cacheRegister.invalidate;
export const documentFoldersCacheRegister = cacheRegister.register;
